import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let companyOverride = null;
export const setCompanyOverride = (id) => { companyOverride = id; };

api.interceptors.request.use((cfg) => {
  const cid = companyOverride || localStorage.getItem("company_id");
  if (cid && !cfg.headers["X-Company-Id"]) cfg.headers["X-Company-Id"] = cid;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 403 ? "Permesso negato" : e?.message || "Si è verificato un errore";
  if (typeof d === "string") return d;
  if (d.message) return d.missing?.length ? `${d.message}: ${d.missing.join(", ")}` : d.message;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const notifyErr = (e) => toast.error(errMsg(e));

export const fmtDate = (v) => {
  if (!v) return "—";
  const s = String(v);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : s;
};
export const fmtDateTime = (v) => {
  if (!v) return "—";
  const s = String(v);
  if (s.includes("+") || s.endsWith("Z")) {
    return new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  }
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : fmtDate(s);
};
export const fmtMoney = (v) =>
  v === null || v === undefined || v === "" ? "—" : Number(v).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export async function fetchBlobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function downloadFile(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) {
    let msg = "Download non riuscito";
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch (_) { /* blob non JSON */ }
    toast.error(msg);
  }
}

export const LABELS = {
  disponibile: "Disponibile", prenotato: "Prenotato", in_noleggio: "In noleggio", in_manutenzione: "In manutenzione",
  non_disponibile: "Non disponibile", bozza: "Bozza", in_attesa: "In attesa", confermata: "Confermata", annullata: "Annullata",
  convertita: "Convertita in noleggio", completata: "Completata", aperto: "Aperto", chiuso: "Chiuso", annullato: "Annullato",
  storico: "Storico importato", pagato: "Pagato", da_incassare: "Da incassare", incasso: "Incasso", deposito: "Deposito",
  rimborso: "Rimborso", saldo: "Saldo", programmata: "Programmata", straordinaria: "Straordinaria", in_corso: "In corso",
  aperta: "Aperta", scaduta: "Scaduta", in_scadenza: "In scadenza", ok: "Regolare", non_inviato: "Non inviato",
  accettato: "Accettato CARGOS", errore: "Errore CARGOS", escluso_storico: "Escluso (storico)", confermato: "Confermato",
  superadmin: "Superadmin", admin: "Admin", operator: "Operatore", carta_identita: "Carta d'identità",
  codice_fiscale: "Codice fiscale / Tessera sanitaria", patente: "Patente", passaporto: "Passaporto", libretto: "Libretto di circolazione",
  contratto: "Contratto", contratto_firmato: "Contratto firmato", generico: "Generico", cliente_documento: "Documento cliente",
  manutenzione: "Manutenzione",
};
export const label = (v) => LABELS[v] || v || "—";

export const TONE = {
  disponibile: "green", completata: "green", pagato: "green", ok: "green", accettato: "green", chiuso: "zinc", confermata: "blue",
  prenotato: "blue", in_attesa: "amber", bozza: "zinc", in_noleggio: "red", aperto: "red", in_manutenzione: "amber",
  in_corso: "amber", programmata: "blue", non_disponibile: "zinc", annullata: "zinc", annullato: "zinc", convertita: "violet",
  storico: "violet", da_incassare: "amber", scaduta: "red", in_scadenza: "amber", errore: "red",
};
